var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7095 0.666992H2.62254C1.54198 0.666992 0.666016 1.53609 0.666016 2.60817V20.7258C0.666016 21.7979 1.54198 22.667 2.62254 22.667H28.7095C29.7901 22.667 30.666 21.7979 30.666 20.7258V2.60817C30.666 1.53609 29.7901 0.666992 28.7095 0.666992Z",
    fill: "#243747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4049 16.8435C15.2864 16.8435 17.6223 14.5259 17.6223 11.667C17.6223 8.80812 15.2864 6.49054 12.4049 6.49054C9.52341 6.49054 7.1875 8.80812 7.1875 11.667C7.1875 14.5259 9.52341 16.8435 12.4049 16.8435Z",
    fill: "#E61C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8854 16.8435C21.7668 16.8435 24.1027 14.5259 24.1027 11.667C24.1027 8.80812 21.7668 6.49054 18.8854 6.49054C16.0039 6.49054 13.668 8.80812 13.668 11.667C13.668 14.5259 16.0039 16.8435 18.8854 16.8435Z",
    fill: "#F99F1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.646 7.6134C15.0293 8.09708 14.5311 8.71298 14.1885 9.41493C13.8459 10.1169 13.668 10.8867 13.668 11.6666C13.668 12.4465 13.8459 13.2163 14.1885 13.9182C14.5311 14.6202 15.0293 15.2361 15.646 15.7198C16.2626 15.2361 16.7609 14.6202 17.1035 13.9182C17.4461 13.2163 17.624 12.4465 17.624 11.6666C17.624 10.8867 17.4461 10.1169 17.1035 9.41493C16.7609 8.71298 16.2626 8.09708 15.646 7.6134Z",
    fill: "#F26622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master_card.0541a6aeb20ed9348792570c17a1b167.svg";
export { ForwardRef as ReactComponent };